export default __webpack_public_path__ + "static/media/logo.c49fb21f.png";